module.exports = __webpack_public_path__ + "img/fig06.1112d311.jpg";